<template>
  <div class="container-fluid main-container m-0 p-0 full" :style="{ 'backgroundImage': `url(${getDestination.backgrounds[0].url})` }">
    <div class="container-fluid bg h-100">
      <div class="row h-100">
        <div class="col-12">
          <div class="row">
            <div class="col text-center p-3">
              <img src="../../assets/images/landing/logo.png" alt="">
            </div>
          </div>
        </div>
        <div
          class="col-12 d-flex justify-content-center align-items-lg-center align-items-end pt-5 mt-5 pt-lg-0 mt-lg-0">
          <div class="container pt-0 mt-5 pt-lg-0 mt-lg-0">
            <div class="row d-flex align-content-center h-100">
              <div class="col-12 col-lg-6 d-lg-grid justify-content-center align-items-center align-self-center">
                <div class="col col-lg-10">
                  <h1 class="lbl-01__title"> {{ getDestination.name }} <br> Luxury Vacation</h1>
                  <h3> <span class="lbl-01__sub px-2">${{ getDestination.price }} USD per 2 adults</span></h3>
                  <p class="lbl-01__p">
                    5-Days & 4-Nights Couple's vacation at a luxury resort.
                  </p>
                </div>
              </div>
              <div class="col-12 col-lg-6 d-flex justify-content-center ">
                <div class="col col-lg-7 mb-2 pb-1 rounded">
                  <TheForm />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center align-items-end">
          <div class="row">
            <div class="col text-center"><img src="../../assets/images/landing/details-section/arrow-down.gif" alt=""
                class="rounded-top-5 p-1 arrow-icon"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <the-details :gallery="getDestination.gallery" :details="getDestination.packageDetails" />

  <div class="container-fluid amenities-bg p-0" :style="{ 'backgroundImage': `url(${this.getDestination.backgrounds[1].url})` }">
    <div class="container-fluid p-0 bg-shadow">
      <div class="row justify-content-around px-2 py-5 align-items-center">
        <div class="col-12 col-lg-4 pb-5 pb-lg-0 lh-sm">
          <h3 class="text-white">{{ getDestination.name }}</h3>
          <span class="h64">{{ getDestination.destinationDescription.title }}</span>
          <h3 class="price-txt">$499 USD per couple
            5 Days & 4 Nights</h3>
          <h4 class="text-white">Regular Price: <span class="text-decoration-line-through"> $1,679</span>
          </h4>
        </div>
        <div class="col-12 col-lg-4 pt-5 pt-lg-0">
          <p class="fs-5 text-white pt-5">
            {{ getDestination.destinationDescription.paragraph }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid highlights-list bg-clouds">
    <div class="container p-lg-5">
      <div class="row gy-4">
        <h3 class="fw-bold pt-5">Highlights</h3>
        <div class="col-12 col-lg-4 mt-0">
          <ul class="list-group list-group-flush">
            <li class="list-group-item"><img src="../../assets/icons/amenities/pool.png" alt="">
              <span></span>Multiple Pools & Beach Access
            </li>
            <li class="list-group-item"><img src="../../assets/icons/amenities/lunch_dining.png" alt="">
              <span></span>Dining Options at 15 Resort Restaurants
            </li>
            <li class="list-group-item"><img src="../../assets/icons/amenities/wine_bar.png" alt="">
              <span></span>Wine Bar & Pool Bar
            </li>
            <li class="list-group-item"><img src="../../assets/icons/amenities/local_activity.png" alt="">
              <span></span>Nightly Entertainment
            </li>
            <li class="list-group-item"><img src="../../assets/icons/amenities/beach_access.png" alt="">
              <span></span>Enjoy Massage and Spa Luxuries
            </li>
            <li class="list-group-item p-0"></li>
          </ul>
        </div>
        <div class="col-12 col-lg-4 mt-0">
          <ul class="list-group list-group-flush">
            <li class="list-group-item"><img src="../../assets/icons/amenities/cleaning_services.png" alt="">
              <span></span>Pool & Beach Wait Service
            </li>
            <li class="list-group-item"><img src="../../assets/icons/amenities/liquor.png" alt="">
              <span></span>Oceanfront Bars & Venues
            </li>
            <li class="list-group-item"><img src="../../assets/icons/amenities/airport_shuttle.png" alt="">
              <span></span>Free Shuttle to and from the Airport
            </li>
            <li class="list-group-item"><img src="../../assets/icons/amenities/room_service.png" alt="">
              <span></span>Room service
            </li>
            <li class="list-group-item p-0"></li>
          </ul>
        </div>
        <div class="col-12 col-lg-4 mt-0">
          <ul class="list-group list-group-flush">
            <li class="list-group-item"><img src="../../assets/icons/amenities/local_laundry_service.png" alt="">
              <span></span>Laundry/Valet Service
            </li>
            <li class="list-group-item"><img src="../../assets/icons/amenities/wifi.png" alt="">
              <span></span>Wi-fi
              throughout the property
            </li>
            <li class="list-group-item"><img src="../../assets/icons/amenities/nest_clock_farsight_analog.png" alt="">
              <span></span>24-hour front desk</li>
            <li class="list-group-item p-0"></li>
          </ul>
        </div>
        <!-- <div class="row px-4 ">
                    <div class="col border border-black">
                        <div class="row justify-content-center">
                            <div class="col-6 col-lg-6  p-3 rounded text-end d-flex align-items-center">
                                <img src="../../assets/icons/amenities/lightbulb_circle.svg" alt=""> <span class="fw-bolder fs-4">Trip Tip!</span>
                            </div>
                            <div class="col-6 col-lg-6 p-3 rounded d-flex align-items-center">
                                <span class="d-inline-block d-lg-flex">Save this deal now and book dates later. You'll have up to 18 months to travel! </span>
                            </div>
                        </div>
                    </div>
                </div> -->
      </div>
      <div class="row p-2 p-lg-0 ">
        <div class="col pb-5 pt-lg-4">
          <div class="row border border-black d-flex align-items-center justify-content-center p-2 p-lg-3">
            <div class="col-lg-4 d-lg-flex justify-content-end align-items-center pb-2 pb-lg-0">
              <img src="../../assets/icons/amenities/lightbulb_circle.svg" alt="" class="pe-1"> <span
                class="fw-bolder fs-4">Trip Tip!</span>
            </div>
            <div class="col-lg-8">
              <span class="d-inline-block d-lg-flex">Save this deal now and book dates later. You'll have
                up
                to 18 months to travel! </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid amenities-bg-03" :style="{ 'backgroundImage': `url(${this.getDestination.backgrounds[2].url})` }">
    <div class="container">
      <div class="row justify-content-around">
        <div class="col-12 mt-5 col-lg-6 lh-base">
          <span class="h64 green-color-text">{{ getDestination.name }}</span>
          <h3 class="text-black pb-5 pb-lg-0 fw-bold">Getaway for 5 Days & 4 Nights</h3>
        </div>
        <div class="col-12 pt-5 col-lg-4">
          <p class="fs-5 text-black m-0 pb-5 mb-5">
            {{ getDestination.packageDescription.paragraph }}
          </p>
        </div>
      </div>
    </div>
  </div>


  <the-reviews />
</template>

<script>
import TheForm from "@/components/landing-page/TheForm.vue";
import TheDetails from "@/components/landing-page/TheDetails.vue"
import TheAmenities from "@/components/landing-page/TheAmenities.vue"
import TheReviews from "@/components/landing-page/TheReviews.vue"
import { ref } from 'vue'
import { useStore } from '@/store/landing';

export default {
  setup() {
    const getImageUrl = (name) => {
      return new URL(`../../assets/${name}`, import.meta.url).href
    }
    return {
      getImageUrl,
      websiteStore: useStore()
    }
  },
  components:
  {
    TheForm,
    TheDetails,
    TheAmenities,
    TheReviews
  },
  computed: {
    getDestination() {
      return this.websiteStore.destinations.find(destination => destination.slug === this.$route.params.destinationSlug)
    },
    getBackground() {
      return 'backgroundImage'+ ':' + `url(${this.getDestination.backgrounds[0]})`
    }
  },
  mounted() {
    // // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    // let vh = window.innerHeight * 0.01;
    // // Then we set the value in the --vh custom property to the root of the document
    // document.documentElement.style.setProperty('--vh', `${vh}px`);
    // // We listen to the resize event
    // window.addEventListener('resize', () => {
    //   // We execute the same script as before
    //   let vh = window.innerHeight * 0.01;
    //   document.documentElement.style.setProperty('--vh', `${vh}px`);
    // });
  }
}


</script>

<style scoped>
.main-container {
  background-image: url(/src/assets/images/landing/bg-01.jpeg);
  background-size: cover;
  background-position-x: center;
  /* height: 100vh !important; */
  /* Fallback for browsers that do not support Custom Properties */
  /* height: calc(var(--vh, 1vh) * 100) !important; */
}

.full {
  height: 100vh !important;
  /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100) !important;
}

.lbl-01__title {
  color: #FFF;
  font-family: "Poppins", sans-serif;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  /* 111.111% */
}

.lbl-01__sub {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background-color: #0C9491;
  color: #FFF;
  font-size: 24px;
}

.lbl-01__p {
  font-family: "Poppins", sans-serif;
  color: #FFF;
}

.bg {
  background-color: rgba(0, 0, 0, .2) !important;
  /* height: 100vh !important; */
  /* Fallback for browsers that do not support Custom Properties */
  /* height: calc(var(--vh, 1vh) * 100) !important; */
}

.my-element {
  /* height: 100vh; */
  /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
}

.margin-15 {
  margin: 0%;
  margin-top: 10rem;
}

.arrow-icon {

  /* margin-left: auto;
margin-right: auto;
left: 0;
right: 0;
text-align: center;
bottom: 0px; */
  background-color: #FFF;
  width: 35px;
  border-top-right-radius: 1rem;
  border-top-left-radius: 1rem;
}


 /*--------------------Amenitties----------*/
 .amenities-bg {
    background-image: url(../../assets/images/landing/backgrounds/bg-amenities.jpeg);
    background-size: cover;
    background-position: center;
  }

  .amenities-bg-03 {
    background-image: url(/src/assets/images/landing/backgrounds/bg-amenities-03.png);
    background-size: cover;
    background-position-x: 50%;
    padding-top: 270px;
  }

  .bg-shadow {
    background-color: rgba(0, 0, 0, .4) !important;
    padding: 5% !important;
  }

  .h64 {
    font-size: 64px;
    color: #ffff;
    font-weight: 900;
  }

  .price-txt {
    background-color: #d50758;
    color: #ffff;
    font-weight: 600;
  }

  .list-group {
    --bs-list-group-item-padding-y: 1rem;
  }

  .list-group-item {
    border-style: dashed;
    padding-left: 0px;
  }

  h3 {
    color: #0c9491;
  }

  .green-color-text {
    color: #0c9491;
  }

  .highlights-list {
    background-color: #dcf3fb;
  }

  .bg-clouds {
    background-image: url(/src/assets/images/landing/backgrounds/clouds.png) !important;
    background-size: contain;
  }

  .list-group-item {
    background-color: transparent;
  }

  @media (min-width: 768px) {
    .amenities-bg-03 {
      padding-top: 20%;
    }
  }

@media (min-width: 992px) {
  .lbl-01__title {
    padding-top: 0%;
    margin-top: 0%;
    color: #FFF;
    font-family: "Poppins", sans-serif;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
    /* 111.111% */
  }


  .p-lg-12 {
    padding: 0rem 9%;
  }

  .margin-15 {
    margin: 11%;
  }
  /* @media (min-width: 992px) {
    .amenities-bg-03 {
        background-image: url(/src/assets/images/backgrounds/bg-amenities-03.png);
    background-size: cover;
    background-position: 50% -30px;
    }
} */
}
</style>